const SORTS = [
    { key: "recommended", label: "Recommended" },
    { key: "recent", label: "Recent" },
    { key: "top_rated", label: "Top Rated" },
    { key: "most_liked", label: "Most Liked" },
    { key: "most_added", label: "Most Added" },
];

export default function DiscoverToolbar({ type, setType, countries = [], countryId, setCountryId, cities = [], cityId, setCityId, sort, setSort }) {
    return (
        <div className="space-y-4" data-testid="discover-toolbar">
            <div className="flex items-center gap-2 rounded-full p-1 w-max" style={{ background: "rgba(0,0,0,0.26)", border: "1px solid rgba(255,255,255,0.08)" }}>
                {[{ key: "trip", label: "Trips" }, { key: "traveldate", label: "Dates" }].map((tab) => (
                    <button
                        key={tab.key}
                        type="button"
                        onClick={() => setType(tab.key)}
                        className="px-4 py-2 rounded-full text-sm transition-colors"
                        style={{ background: type === tab.key ? "var(--gold)" : "transparent", color: type === tab.key ? "var(--navy)" : "white" }}
                        data-testid={`discover-tab-${tab.key === "trip" ? "trips" : "dates"}`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div className="grid gap-3 md:grid-cols-[1fr_1fr] xl:grid-cols-[180px_220px_1fr]">
                <label className="rounded-2xl px-4 py-3" style={{ background: "var(--navy-deep)", border: "1px solid rgba(255,255,255,0.08)" }}>
                    <div className="text-[10px] uppercase tracking-[0.22em] text-white/40 mb-2">Country</div>
                    <select value={countryId} onChange={(e) => { setCountryId(e.target.value); setCityId(""); }} className="w-full bg-transparent text-white text-sm focus:outline-none" data-testid="discover-filter-country-select">
                        <option value="" className="text-slate-900">All countries</option>
                        {countries.map((country) => <option key={country.country_id} value={country.country_id} className="text-slate-900">{country.country_name}</option>)}
                    </select>
                </label>

                <label className="rounded-2xl px-4 py-3" style={{ background: "var(--navy-deep)", border: "1px solid rgba(255,255,255,0.08)" }}>
                    <div className="text-[10px] uppercase tracking-[0.22em] text-white/40 mb-2">City</div>
                    <select value={cityId} onChange={(e) => setCityId(e.target.value)} className="w-full bg-transparent text-white text-sm focus:outline-none" data-testid="discover-filter-city-select" disabled={!countryId}>
                        <option value="" className="text-slate-900">All cities</option>
                        {cities.map((city) => <option key={city.city_id} value={city.city_id} className="text-slate-900">{city.city_name}</option>)}
                    </select>
                </label>

                <div className="flex flex-wrap gap-2" data-testid="discover-sort-controls">
                    {SORTS.map((option) => (
                        <button
                            key={option.key}
                            type="button"
                            onClick={() => setSort(option.key)}
                            className="px-4 py-2 rounded-full text-xs md:text-sm transition-colors"
                            style={{ background: sort === option.key ? "rgba(212,175,55,0.16)" : "rgba(255,255,255,0.05)", color: sort === option.key ? "var(--gold)" : "rgba(255,255,255,0.82)", border: `1px solid ${sort === option.key ? "rgba(212,175,55,0.34)" : "rgba(255,255,255,0.08)"}` }}
                            data-testid={`discover-sort-${option.key.replace(/_/g, "-")}`}
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}